import { Device } from '@capacitor/device';
import { LanguageString } from '@sworkit/api';

export async function getDeviceType() {
  const deviceData = await Device.getInfo();
  return `${deviceData.model}-${deviceData.osVersion}`;
}

export async function getDeviceLanguage() {
  try {
    const { value: deviceLanguage } = await Device.getLanguageCode();
    const lang = removeCountryCode(deviceLanguage);
    return lang;
  } catch (err) {
    console.debug('error getting language from device', err);
    return 'en';
  }
}

function removeCountryCode(languageCode: string) {
  if (languageCode) {
    return languageCode.split('-')[0].toLowerCase() as LanguageString;
  } else {
    return 'en';
  }
}
